import { formatDistanceToNow } from 'date-fns';
import { ar } from 'date-fns/locale';

export const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (hours > 0) {
    return `${hours} ساعة ${minutes} دقيقة`;
  } else if (minutes > 0) {
    return `${minutes} دقيقة ${remainingSeconds} ثانية`;
  } else {
    return `${remainingSeconds} ثانية`;
  }
};

export const formatDate = (date: Date | number | string | null | undefined): string => {
  if (!date) return 'غير متوفر';
  
  try {
    const dateObj = date instanceof Date ? date : new Date(date);
    
    // التحقق من صحة التاريخ
    if (isNaN(dateObj.getTime())) {
      return 'تاريخ غير صالح';
    }
    
    return formatDistanceToNow(dateObj, {
      addSuffix: true,
      locale: ar
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'تاريخ غير صالح';
  }
};

export const formatLocalDate = (date: Date | number | string | null | undefined): string => {
  if (!date) return 'غير متوفر';
  
  try {
    const dateObj = date instanceof Date ? date : new Date(date);
    
    // التحقق من صحة التاريخ
    if (isNaN(dateObj.getTime())) {
      return 'تاريخ غير صالح';
    }
    
    return dateObj.toLocaleDateString('ar-EG');
  } catch (error) {
    console.error('Error formatting local date:', error);
    return 'تاريخ غير صالح';
  }
};
